var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 68,
    viewBox: "0 0 97 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.292 14.6667C27.2201 14.6667 26.1921 15.053 25.4341 15.7406C24.6761 16.4283 24.2503 17.3609 24.2503 18.3333V69.6667C24.2503 70.6391 24.6761 71.5718 25.4341 72.2594C26.1921 72.947 27.2201 73.3333 28.292 73.3333H68.7087C69.7806 73.3333 70.8086 72.947 71.5666 72.2594C72.3245 71.5718 72.7503 70.6391 72.7503 69.6667L72.7503 34.5188L50.8683 14.6671L28.292 14.6667ZM19.7183 10.5552C21.9922 8.49227 25.0762 7.33334 28.292 7.33334H50.8687C53.0122 7.33376 55.0686 8.1065 56.5841 9.48162M56.5841 9.48162L78.4652 29.3326C78.4651 29.3324 78.4654 29.3327 78.4652 29.3326C79.981 30.7075 80.8332 32.5727 80.8337 34.5172V69.6667C80.8337 72.5841 79.5562 75.382 77.2823 77.4449C75.0085 79.5078 71.9244 80.6667 68.7087 80.6667H28.292C25.0762 80.6667 21.9922 79.5078 19.7183 77.4449C17.4444 75.382 16.167 72.5841 16.167 69.6667V18.3333C16.167 15.416 17.4444 12.6181 19.7183 10.5552M32.3337 44C32.3337 41.975 34.1432 40.3333 36.3753 40.3333H60.6253C62.8575 40.3333 64.667 41.975 64.667 44C64.667 46.0251 62.8575 47.6667 60.6253 47.6667H36.3753C34.1432 47.6667 32.3337 46.0251 32.3337 44ZM32.3337 58.6667C32.3337 56.6416 34.1432 55 36.3753 55H60.6253C62.8575 55 64.667 56.6416 64.667 58.6667C64.667 60.6917 62.8575 62.3333 60.6253 62.3333H36.3753C34.1432 62.3333 32.3337 60.6917 32.3337 58.6667Z",
    fill: "#515B6F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.3335,
    y: 40.3333,
    width: 32.3333,
    height: 7.33333,
    rx: 3.66667,
    fill: "#26A4FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.3335,
    y: 55,
    width: 32.3333,
    height: 7.33333,
    rx: 3.66667,
    fill: "#26A4FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocImage);
export default __webpack_public_path__ + "static/media/docImage.efed072259a48be5363846a5e7e2967c.svg";
export { ForwardRef as ReactComponent };